export const MODULES = [
  ["overview", "Today", "Workspace", null],
  ["contacts", "Contacts", "Relationships", "crm.read"],
  ["companies", "Companies", "Relationships", "crm.read"],
  ["partners", "Partners", "Relationships", "partners.read"],
  ["submissions", "Inbox", "Relationships", "crm.read"],
  ["orders", "Orders", "Relationships", "commerce.read"],
  ["course-enrollments", "Course enrollments", "Access & support", "customers.read"],
  ["course-delivery", "Course delivery", "Publishing", "grants.manage"],
  ["applications", "Applications", "Recruiting", "recruiting.read"],
  ["assessments", "Assessments", "Recruiting", "recruiting.read"],
  ["customers", "Customers", "Access & support", "customers.read"],
  ["grants", "File access", "Access & support", "customers.read"],
  ["grant-history", "Access history", "Access & support", "customers.read"],
  ["support", "Support inbox", "Access & support", "support.manage"],
  ["resources", "Resource library", "Publishing", "resources.read"],
  ["paperwork", "Paperwork", "Publishing", "paperwork.products.edit"],
  ["versions", "File versions", "Publishing", "resources.read"],
  ["scans", "File checks", "Publishing", "resources.read"],
  ["legacy-resources", "Existing resource pages", "Publishing", "content.read"],
  ["blogs", "Blog posts", "Publishing", "content.read"],
  ["services", "Service pages", "Publishing", "content.read"],
  ["service-catalogue", "Service catalogue", "Publishing", "content.read"],
  ["speakers", "Speakers", "Publishing", "content.read"],
  ["course-library", "Course library", "Publishing", "content.read"],
  ["courses", "Featured course promotion", "Publishing", "content.read"],
  ["site-content", "Site content", "Publishing", "content.read"],
  ["media", "Public media", "Publishing", "content.read"],
  ["email", "Email operations", "Operations", "email.manage"],
  ["sync", "TMS sync", "Operations", "integrations.read"],
  ["mappings", "TMS mappings", "Operations", "integrations.read"],
  ["exports", "My exports", "Operations", "exports"],
  ["audit", "Audit trail", "Operations", "audit.read"],
  ["privacy", "Privacy requests", "Operations", "privacy.manage"],
  ["team", "Team & security", "Administration", "team.manage"],
  ["invitations", "Invitations", "Administration", "team.manage"],
  ["settings", "Settings", "Administration", "settings.manage"],
];
export const CMS = [
  "legacy-resources",
  "blogs",
  "services",
  "service-catalogue",
  "courses",
  "speakers",
  "course-library",
  "site-content",
  "media",
];
export const FILTERS = {
  contacts: ["status", "email", "source"],
  companies: ["status", "email"],
  submissions: ["status", "kind", "contactId"],
  applications: ["status"],
  assessments: ["applicationId"],
  customers: ["status", "email"],
  grants: ["customerId", "resourceId", "status"],
  "grant-history": ["customerId", "resourceId"],
  resources: ["status", "category"],
  versions: ["resourceId", "status"],
  scans: ["status", "versionId"],
  support: ["customerId", "status"],
  email: ["status", "kind"],
  sync: ["status", "type"],
  mappings: ["entityId"],
  audit: ["actor", "action", "target"],
  privacy: ["status"],
  team: ["active", "role"],
  invitations: ["email"],
  exports: ["status"],
};
export const SEARCH = [
  "contacts",
  "companies",
  "applications",
  "customers",
  "resources",
];
export const ANNOTATE = [
  "contacts",
  "companies",
  "submissions",
  "applications",
];
// Records whose detail opens beside the list (split view). Editors and forms that need the
// full width (content, settings, paperwork products, course delivery) keep a page of their own.
const FULL_PAGE = ["overview", "submissions", "resources", "speakers", "course-library", "course-delivery", "course-enrollments", "paperwork", "settings", "sync"];
export const splitView = (domain) => Boolean(domain) && !CMS.includes(domain) && !FULL_PAGE.includes(domain);
export const endpoint = (domain) =>
  `/admin/${CMS.includes(domain) ? "cms/" : ""}${domain}`;
export const titleOf = (row) =>
  row.title ||
  row.name ||
  row.companyName ||
  row.displayName ||
  row.subject ||
  row.payload?.name ||
  row.payload?.companyName ||
  row.email ||
  row.fileName ||
  row.type ||
  row.kind ||
  row.id;
export const ROLES = [
  "owner",
  "super_admin",
  "admin",
  "editor",
  "sales",
  "recruiter",
  "support",
  "readonly",
  "accountant",
];
